import { render, staticRenderFns } from "./MenuGeneral.vue?vue&type=template&id=2948683c&scoped=true&"
import script from "./MenuGeneral.vue?vue&type=script&lang=js&"
export * from "./MenuGeneral.vue?vue&type=script&lang=js&"
import style0 from "./MenuGeneral.vue?vue&type=style&index=0&id=2948683c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2948683c",
  null
  
)

export default component.exports